import { Endpoint } from '../endpoint';
import {
  UserCourseStepResponse,
  UserCourseId,
  UserCourseResponse,
  UserCourseStepId,
  CourseStepAnswers,
  CourseStepProgressResponse,
  CourseSessionId,
} from '@business/entities/user_course';
import { CourseId } from '@business/entities/course';
import { CompactUserResponse, UserId } from '@business/entities/account';
import { R } from '@core/utils/r';

export function fetchCourse(id: UserCourseId) {
  return Endpoint.get<UserCourseResponse>(`@makh/user-courses/course/${id}`);
}

export function fetchUserCourseVersions(courseId: CourseId, userId?: UserId) {
  const params = R.objectCompact({ courseId, userId });
  return Endpoint.get<UserCourseResponse[]>(`@makh/user-courses/user-course-versions`, { params });
}

export function stepComplete(id: UserCourseId, stepId: UserCourseStepId, answers: CourseStepAnswers) {
  return Endpoint.post<UserCourseStepResponse>(`@makh/user-courses/mark-complete/${id}/${stepId}`, { data: { answers } });
}

export function onProgress(stepId: string, progress: CourseStepAnswers) {
  return Endpoint.post<CourseStepProgressResponse>(`@makh/user-courses/user-progress/${stepId}`, { data: { progress } });
}

export function submitEssay(stepId: string, progress: CourseStepAnswers) {
  // const formData = CommonService.toFormData(progress);
  return Endpoint.post<CourseStepProgressResponse>(`@makh/user-courses/user-essay/${stepId}`, { data: progress });
}

export function fetchCourseSessionId() {
  return Endpoint.get<CourseSessionId>(`@makh/user-courses/course-session-id`);
}

export function createStepTracker(stepId: UserCourseStepId, sessionId: CourseSessionId, time: number) {
  return Endpoint.post<void>(`@makh/user-courses/step-tracker`, { data: { stepId, sessionId, time } });
}

export function fetchAssignedCourseUsers() {
  return Endpoint.get<CompactUserResponse>(`@makh/user-courses/users`);
}
